import './RefreshIcon.css'

import React, { memo } from 'react'
import { ColorValue, ViewStyle } from 'react-native'

import RefreshSvg from '@common/assets/svg/RefreshIcon'

// We are setting the width and height for both the wrapping div and the SVG.
// Otherwise, the spinning animation breaks.
const RefreshIcon = ({
  color,
  spin,
  width,
  height
}: {
  color?: ColorValue
  spin?: boolean
  width: ViewStyle['width']
  height: ViewStyle['height']
}) => {
  return (
    <div
      className={spin ? 'spinAnimation' : ''}
      style={{ width: width as any, height: height as any }}
    >
      <RefreshSvg color={color} width={width as any} height={height as any} />
    </div>
  )
}

export default memo(RefreshIcon)
